import React from "react";
import { ProgressBar } from "primereact/progressbar";

const Loader = (props) => {
    
  return (
    <>
      <div className="loader-overlay">
        <ProgressBar
          mode="indeterminate"
          color="var(--main-color)"
          style={{ height: "5px" }}
        ></ProgressBar>{" "}
      </div>
    </>
  );
};

export default Loader;
